import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getownermodalstatsSlice = createSlice({
    name: 'ownermodalstats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchownermodalstats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchownermodalstats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchownermodalstats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    }
});

export const { setTrainer, setStatus } = getownermodalstatsSlice.actions;
export default getownermodalstatsSlice.reducer;

export const fetchownermodalstats = createAsyncThunk('/HorsemodalaccForStatisitics/fetch', async ({ year, id } = {}) => {
    const cleanId = id?._id || id?.id || (typeof id === 'string' ? id : "");
    if (!cleanId) return {};
    const query = (year !== undefined && year !== null && year !== "") ? `?year=${year}` : "";
    const res = await axios.get(`${getBaseUrl()}/OwnerStatsModal/${cleanId}${query}`);
    const trainerstatsData = res.data;
    return trainerstatsData;
});
